import Button from '@material-ui/core/Button';
import { alpha, makeStyles, styled } from '@material-ui/core/styles';

export const GradientButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  color: 'white',
  fontWeight: 600,
  borderRadius: 8,
  padding: theme.spacing(1.5, 3),
  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  '&:hover': {
    boxShadow: '0 6px 8px rgba(0,0,0,0.15)',
  },
}));

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    backgroundColor: '#f9fafc',
    minHeight: '79vh',
  },
  header: {
    marginBottom: theme.spacing(4),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  card: {
    borderRadius: 12,
    boxShadow: '0 8px 16px 0 rgba(0,0,0,0.04)',
    marginBottom: theme.spacing(4),
    overflow: 'visible',
  },
  cardHeader: {
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  cardContent: {
    padding: theme.spacing(3),
  },
  table: {
    marginTop: theme.spacing(3),
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    '& .MuiTableCell-head': {
      fontWeight: 600,
    },
  },
  formRow: {
    display: 'flex',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  uploadArea: {
    border: `2px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
    borderRadius: 12,
    padding: theme.spacing(4),
    textAlign: 'center',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.03),
    },
  },
  processChip: {
    margin: theme.spacing(0.5),
    backgroundColor: '#e3f2fd',
    color: theme.palette.primary.dark,
  },
  actionButton: {
    borderRadius: 8,
    textTransform: 'none',
    padding: theme.spacing(1, 2),
    boxShadow: 'none',
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  dialogPaper: {
    borderRadius: 16,
    padding: theme.spacing(1),
  },
  priceIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    borderRadius: 16,
    padding: theme.spacing(0.5, 1.5),
    fontWeight: 500,
  },
  costIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#fff3e0',
    color: '#e65100',
    borderRadius: 16,
    padding: theme.spacing(0.5, 1.5),
    fontWeight: 500,
  },
  searchContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  noDataContainer: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  loadingContainer: {
    padding: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
